module.exports = __webpack_public_path__ + "static/media/certificate-awwwards-4-seasons-slot-machine-hm_01-08-2022.16eaca67.pdf";